import { Box, type SxProps, type Theme, useTheme } from "@mui/material";
import type { PropsWithChildren } from "react";
import { forwardRef, useId } from "react";
import { SabCircularProgress } from "web_myplann/Shared/Progresses";

export interface MobileLayoutContentProps {
	disableContentPadding?: boolean;
	disableBottomPadding?: boolean;
	refreshing?: boolean;
	mainSx?: SxProps<Theme>;
	handlers?: any;
}

export const MobileLayoutContent = forwardRef<
	HTMLDivElement,
	PropsWithChildren<MobileLayoutContentProps>
>((props, ref) => {
	const { children, disableContentPadding, refreshing, mainSx, handlers } =
		props;
	const theme = useTheme();
	const id = useId();

	if (!children) return null;

	return (
		<Box
			id={id}
			flexGrow={1}
			paddingX={disableContentPadding ? undefined : 1.6}
			component="main"
			sx={[
				{
					overflow: "auto",
					overscrollBehavior: "none",
					minHeight: 0,
					paddingBottom: 0,
				},
				...(Array.isArray(mainSx) ? mainSx : mainSx ? [mainSx] : []),
			]}
			ref={ref}
			{...handlers}
		>
			{refreshing && (
				<Box
					sx={{
						left: "50%",
						top: "50%",
						position: "fixed",
						zIndex: theme.zIndex.tooltip,
						transform: "translate(-50%, -50%)",
					}}
				>
					<SabCircularProgress size={"xxl"} />
				</Box>
			)}

			{children}
		</Box>
	);
});
